Service = App.loadClass 'core::Angular/Service'

class exports.ZonesService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    save: (data) ->
        return @http.post 'backend/grower/layers/management-zones/add-new', { 'data': data }

    load: (id, cb) ->
        @http.post('backend/grower/layers/management-zones/get-object',
            { 'id': id })
        .then (response) =>
            cb(response)

    getIrrigationZoneByFieldYear: (field_id, year) ->
        return @http.post('backend/grower/layers/management-zones/get-existing-irrigation', { field_id, year })

    hasExistingPreviousCropZone: (field_id, year) ->
        return @http.post('backend/grower/layers/management-zones/has-existing-previous-crop', { field_id, year })

    exists: (id, cb) ->
        @http.post('backend/grower/layers/management-zones/zone-exists',
            { 'id': id })
        .then (response) =>
            cb(response)

    crops: () ->
        return @http.post('backend/grower/layers/management-zones/get-crops-list').then (response) =>
            return response.data.data

    # styling defaults for zones on the front end
    defaultZoneStyle: (use_default = true, fill = false, weight = 2, use_dash = false) =>
        color = if use_default is true then '#FFFFFF' else use_default
        fill = color if not fill

        return {
            weight: weight
            fillColor: fill
            fillOpacity: 0.6
            color: color
            dashArray: [10, 8] if use_dash
        }

    setZoneArea: (zone) ->
        zone.area = () =>
            # get the zones geojson
            geojson = zone.visible.toGeoJSON()

            if App.is_metric
                return turf.area(geojson) * 0.0001
            else
                return turf.area(geojson) * 0.000247105

        return zone

    getNextColor: (color, by_index = null) =>
        colors = [
            '#303F99'
            '#F2DC10'
            '#F08A2E'
            '#D51F26'
            '#00ACE1'
            '#A65392'
            '#EB468C'
            '#008161'
            '#974B19'
            '#36415A'
            '#231F20'
        ]

        if by_index
            # get a color by index
            return colors[by_index]
        else
            # determine the next color based on the current color
            curr = colors.indexOf(color)
            nextColorIndex = (curr + 1) % colors.length

            return colors[nextColorIndex]
